// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3oyX5","label":"Radio_label__19DBB","checkMark":"Radio_checkMark__3WKt5","disabled":"Radio_disabled__1cPbP"};